/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable complexity */
/* eslint-disable unicorn/prevent-abbreviations */
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';

const EVENT_KEY = `.lta.wtn`;
const EVENT_CLICK = `click.${EVENT_KEY}`;

const SELECTOR_WTN_WIDGET_CONTAINER = '[data-lta-wtn-widget]';

const SINGLES_EVENT_SELECTOR = '#lta-wtn-tab-1';
const DOUBLES_EVENT_SELECTOR = '#lta-wtn-tab-2';

class PlayerDashboardWTNSection {
	constructor() {
		this.moreInfoBtns = undefined;

		this.mode = '-';
		this.wtnSingles = '0';
		this.wtnDoubles = '0';
		this.wtnProplayersingles = false;
		this.wtnProplayerdoubles = false;
		this.wtnConfidencesingles = '0';
		this.wtnConfidencedoubles = '0';
		this.wtnGamezoneupper = '0';
		this.wtnGamezonelower = '0';
		this.wtnSourceispsqsingles = false;
		this.wtnSourceispsqdoubles = false;

		this.WTNScale = undefined;
		this.React = undefined;
		this.ReactDOM = undefined;

		this.singlesCta = undefined;
		this.doublesCta = undefined;
		this.itfTennisId = undefined;
	}

	init() {
		const wtnWidgetContainerEl = SelectorEngine.findOne(SELECTOR_WTN_WIDGET_CONTAINER);

		if (wtnWidgetContainerEl !== null) {
			const props = Manipulator.getDataAttributes(wtnWidgetContainerEl);

			this.mode = props.mode || this.mode;
			this.wtnSingles = props.wtnSingles || props.wtnSingles;
			this.wtnDoubles = props.wtnDoubles || props.wtnDoubles;
			this.wtnProplayersingles = props.wtnProplayersingles || this.wtnProplayersingles;
			this.wtnProplayerdoubles = props.wtnProplayerdoubles || this.wtnProplayerdoubles;
			this.wtnConfidencesingles = props.wtnConfidencesingles || this.wtnConfidencesingles;
			this.wtnConfidencedoubles = props.wtnConfidencedoubles || this.wtnConfidencedoubles;
			this.wtnGamezoneupper = Number(props.wtnGamezoneupper) || this.wtnGamezoneupper;
			this.wtnGamezonelower = Number(props.wtnGamezonelower) || this.wtnGamezonelower;
			this.wtnSourceispsqdoubles =
				props.wtnSourceispsqdoubles?.toString().toLowerCase() === 'true' || this.wtnSourceispsqdoubles;
			this.wtnSourceispsqsingles =
				props.wtnSourceispsqsingles?.toString().toLowerCase() === 'true' || this.wtnSourceispsqsingles;

			this.moreInfoBtns = SelectorEngine.find('.itf-wtn-info-btn');
			this.itfTennisId = props.wtnItftennisid || this.itfTennisId;

			this.singlesCta = SelectorEngine.findOne(SINGLES_EVENT_SELECTOR);
			if (this.singlesCta) {
				this.singlesCta.addEventListener('click', () => {
					this.renderWidget('singles');
				});
			}

			this.doublesCta = SelectorEngine.findOne(DOUBLES_EVENT_SELECTOR);
			if (this.doublesCta) {
				this.doublesCta.addEventListener('click', () => {
					this.renderWidget('doubles');
				});
			}

			this.initEvents();
			this.initWTN();
		}
	}

	// eslint-disable-next-line require-await
	async initEvents() {
		// eslint-disable-next-line array-callback-return
		this.moreInfoBtns.map((el) => {
			EventHandler.on(el, EVENT_CLICK, () => {
				Manipulator.toggleClass(el, 'is-open');
			});
		});
	}

	async initWTN() {
		this.WTNScale = await import('./../../../vendors/wtn-component-library/build/index.es');
		this.React = await import('react');
		this.ReactDOM = await import('react-dom');

		this.renderWidget(this.mode);
		if(this.wtnSingles || this.wtnDoubles) {
			this.renderGraphWidget(this.itfTennisId);
		}
	}

	renderGraphWidget(itfId) {
		ReactDOM.render(
			React.createElement(ClubsparkITFModule.WTNHistoryGraph, {
			  tennisID: itfId,
			  mobileBreakPoint: 800,
			}),
			document.querySelector(".history-graph")
		  );
	}

	renderWidget(mode) {
		this.ReactDOM.render(
			this.React.createElement(this.WTNScale.WTNScale, {
				mode: mode,
				width: 300,
				wtnSingles: this.wtnSingles,
				wtnDoubles: this.wtnDoubles,
				proPlayerSingles: this.wtnProplayersingles,
				proPlayerDoubles: this.wtnProplayerdoubles,
				animDuration: 4000,
				confidenceSingles: this.wtnConfidencesingles,
				confidenceDoubles: this.wtnConfidencedoubles,
				gameZoneUpper: this.wtnGamezoneupper,
				gameZoneLower: this.wtnGamezonelower,
				sourceIsPsqSingles: this.wtnSourceispsqsingles,
				sourceIsPsqDoubles: this.wtnSourceispsqdoubles
			}),
			document.querySelector('.js-itf-wtn-widget-container')
		);
	}
}

export default PlayerDashboardWTNSection;
